// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/workspace/mars-web/node_modules/.pnpm/dva-loading@3.0.25_dva-core@2.0.4_redux@4.2.1_/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelAppModel0 from '/workspace/mars-web/apps/base-app/src/models/app/app.model.ts';
import ModelShipNetModel1 from '/workspace/mars-web/apps/base-app/src/models/appSettings/shipNet/shipNet.model.ts';
import ModelAdjustmentOrderModel2 from '/workspace/mars-web/apps/base-app/src/models/check/adjustmentOrder/adjustmentOrder.model.ts';
import ModelAdjustmentReasonModel3 from '/workspace/mars-web/apps/base-app/src/models/check/adjustmentReason/adjustmentReason.model.ts';
import ModelCheckOrderModel4 from '/workspace/mars-web/apps/base-app/src/models/check/checkOrder/checkOrder.model.ts';
import ModelStockCostAdjustmentModel5 from '/workspace/mars-web/apps/base-app/src/models/check/stockCostAdjustment/stockCostAdjustment.model.ts';
import ModelStockTransferModel6 from '/workspace/mars-web/apps/base-app/src/models/check/stockTransfer/stockTransfer.model.ts';
import ModelBrandModel7 from '/workspace/mars-web/apps/base-app/src/models/document/brand/brand.model.ts';
import ModelCostCardManagementModel8 from '/workspace/mars-web/apps/base-app/src/models/document/costCard/costCardManagement.model.ts';
import ModelProductCostCardModel9 from '/workspace/mars-web/apps/base-app/src/models/document/costCard/productCostCard.model.ts';
import ModelEntryExitDetailsModel10 from '/workspace/mars-web/apps/base-app/src/models/document/entryExitDetails/entryExitDetails.model.ts';
import ModelGoodsInventoryModel11 from '/workspace/mars-web/apps/base-app/src/models/document/goodsInventory/goodsInventory.model.ts';
import ModelProductModel12 from '/workspace/mars-web/apps/base-app/src/models/document/product/product.model.ts';
import ModelQueryTemplateModel13 from '/workspace/mars-web/apps/base-app/src/models/document/queryTemplate/queryTemplate.model.ts';
import ModelSettingsModel14 from '/workspace/mars-web/apps/base-app/src/models/document/settings/settings.model.ts';
import ModelStatisticsOfChangeModel15 from '/workspace/mars-web/apps/base-app/src/models/document/statisticsOfChange/statisticsOfChange.model.ts';
import ModelStoreOrderModel16 from '/workspace/mars-web/apps/base-app/src/models/document/store/storeOrder.model.ts';
import ModelVirtualItemModel17 from '/workspace/mars-web/apps/base-app/src/models/document/virtualItem/virtualItem.model.ts';
import ModelEarthInnerApplyOrderModel18 from '/workspace/mars-web/apps/base-app/src/models/earthOrders/earthInnerApplyOrder/earthInnerApplyOrder.model.ts';
import ModelEarthLocationReplenishmentModel19 from '/workspace/mars-web/apps/base-app/src/models/earthOrders/earthLocationReplenishment/earthLocationReplenishment.model.ts';
import ModelEarthTransferInOrderModel20 from '/workspace/mars-web/apps/base-app/src/models/earthOrders/earthTransferInOrder/earthTransferInOrder.model.ts';
import ModelEarthTransferOutOrderModel21 from '/workspace/mars-web/apps/base-app/src/models/earthOrders/earthTransferOutOrder/earthTransferOutOrder.model.ts';
import ModelGoodsFormulaModel22 from '/workspace/mars-web/apps/base-app/src/models/goods/goodsFormula/goodsFormula.model.ts';
import ModelDistributionGrossProfitModel23 from '/workspace/mars-web/apps/base-app/src/models/orders/distributionGrossProfit/distributionGrossProfit.model.ts';
import ModelInnerApplyOrderModel24 from '/workspace/mars-web/apps/base-app/src/models/orders/innerApplyOrder/innerApplyOrder.model.ts';
import ModelLocationChainPriceModel25 from '/workspace/mars-web/apps/base-app/src/models/orders/locationChainPrice/locationChainPrice.model.ts';
import ModelOrderingControlModel26 from '/workspace/mars-web/apps/base-app/src/models/orders/orderingControl/orderingControl.model.ts';
import ModelProductLocationPropModel27 from '/workspace/mars-web/apps/base-app/src/models/orders/productLocationProp/productLocationProp.model.ts';
import ModelReplenishmentGuideModel28 from '/workspace/mars-web/apps/base-app/src/models/orders/replenishmentGuide/replenishmentGuide.model.ts';
import ModelRequestOrderModel29 from '/workspace/mars-web/apps/base-app/src/models/orders/requestOrder/requestOrder.model.ts';
import ModelRequestOrderStatisticsModel30 from '/workspace/mars-web/apps/base-app/src/models/orders/requestOrderStatistics/requestOrderStatistics.model.ts';
import ModelRequestOrderTemplateModel31 from '/workspace/mars-web/apps/base-app/src/models/orders/requestOrderTemplate/requestOrderTemplate.model.ts';
import ModelTransferInOrderModel32 from '/workspace/mars-web/apps/base-app/src/models/orders/transferInOrder/transferInOrder.model.ts';
import ModelTransferOutOrderModel33 from '/workspace/mars-web/apps/base-app/src/models/orders/transferOutOrder/transferOutOrder.model.ts';
import ModelTransiGoodsModel34 from '/workspace/mars-web/apps/base-app/src/models/orders/transiGoods/transiGoods.model.ts';
import ModelFinishedRateReportModel35 from '/workspace/mars-web/apps/base-app/src/models/process/finishedRateReport/finishedRateReport.model.ts';
import ModelFormulaModel36 from '/workspace/mars-web/apps/base-app/src/models/process/formula/formula.model.ts';
import ModelProductionBoardModel37 from '/workspace/mars-web/apps/base-app/src/models/process/productionBoard/productionBoard.model.ts';
import ModelProductionPlanModel38 from '/workspace/mars-web/apps/base-app/src/models/process/productionPlan/productionPlan.model.ts';
import ModelProductionProcessModel39 from '/workspace/mars-web/apps/base-app/src/models/process/productionProcess/productionProcess.model.ts';
import ModelProductionStorageModel40 from '/workspace/mars-web/apps/base-app/src/models/process/productionStorage/productionStorage.model.ts';
import ModelPurchaseOrderModel41 from '/workspace/mars-web/apps/base-app/src/models/purchasing/purchaseOrder/purchaseOrder.model.ts';
import ModelReceiveOrderModel42 from '/workspace/mars-web/apps/base-app/src/models/purchasing/receiveOrder/receiveOrder.model.ts';
import ModelReturnOrderModel43 from '/workspace/mars-web/apps/base-app/src/models/purchasing/returnOrder/returnOrder.model.ts';
import ModelSummaryDetailsModel44 from '/workspace/mars-web/apps/base-app/src/models/purchasing/summaryDetails/summaryDetails.model.ts';
import ModelSupplierModel45 from '/workspace/mars-web/apps/base-app/src/models/purchasing/supplier/supplier.model.ts';
import ModelSupplierUserModel46 from '/workspace/mars-web/apps/base-app/src/models/purchasing/supplierUser/supplierUser.model.ts';
import ModelSupplyModel47 from '/workspace/mars-web/apps/base-app/src/models/purchasing/supply/supply.model.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'app.model', ...ModelAppModel0 });
app.model({ namespace: 'shipNet.model', ...ModelShipNetModel1 });
app.model({ namespace: 'adjustmentOrder.model', ...ModelAdjustmentOrderModel2 });
app.model({ namespace: 'adjustmentReason.model', ...ModelAdjustmentReasonModel3 });
app.model({ namespace: 'checkOrder.model', ...ModelCheckOrderModel4 });
app.model({ namespace: 'stockCostAdjustment.model', ...ModelStockCostAdjustmentModel5 });
app.model({ namespace: 'stockTransfer.model', ...ModelStockTransferModel6 });
app.model({ namespace: 'brand.model', ...ModelBrandModel7 });
app.model({ namespace: 'costCardManagement.model', ...ModelCostCardManagementModel8 });
app.model({ namespace: 'productCostCard.model', ...ModelProductCostCardModel9 });
app.model({ namespace: 'entryExitDetails.model', ...ModelEntryExitDetailsModel10 });
app.model({ namespace: 'goodsInventory.model', ...ModelGoodsInventoryModel11 });
app.model({ namespace: 'product.model', ...ModelProductModel12 });
app.model({ namespace: 'queryTemplate.model', ...ModelQueryTemplateModel13 });
app.model({ namespace: 'settings.model', ...ModelSettingsModel14 });
app.model({ namespace: 'statisticsOfChange.model', ...ModelStatisticsOfChangeModel15 });
app.model({ namespace: 'storeOrder.model', ...ModelStoreOrderModel16 });
app.model({ namespace: 'virtualItem.model', ...ModelVirtualItemModel17 });
app.model({ namespace: 'earthInnerApplyOrder.model', ...ModelEarthInnerApplyOrderModel18 });
app.model({ namespace: 'earthLocationReplenishment.model', ...ModelEarthLocationReplenishmentModel19 });
app.model({ namespace: 'earthTransferInOrder.model', ...ModelEarthTransferInOrderModel20 });
app.model({ namespace: 'earthTransferOutOrder.model', ...ModelEarthTransferOutOrderModel21 });
app.model({ namespace: 'goodsFormula.model', ...ModelGoodsFormulaModel22 });
app.model({ namespace: 'distributionGrossProfit.model', ...ModelDistributionGrossProfitModel23 });
app.model({ namespace: 'innerApplyOrder.model', ...ModelInnerApplyOrderModel24 });
app.model({ namespace: 'locationChainPrice.model', ...ModelLocationChainPriceModel25 });
app.model({ namespace: 'orderingControl.model', ...ModelOrderingControlModel26 });
app.model({ namespace: 'productLocationProp.model', ...ModelProductLocationPropModel27 });
app.model({ namespace: 'replenishmentGuide.model', ...ModelReplenishmentGuideModel28 });
app.model({ namespace: 'requestOrder.model', ...ModelRequestOrderModel29 });
app.model({ namespace: 'requestOrderStatistics.model', ...ModelRequestOrderStatisticsModel30 });
app.model({ namespace: 'requestOrderTemplate.model', ...ModelRequestOrderTemplateModel31 });
app.model({ namespace: 'transferInOrder.model', ...ModelTransferInOrderModel32 });
app.model({ namespace: 'transferOutOrder.model', ...ModelTransferOutOrderModel33 });
app.model({ namespace: 'transiGoods.model', ...ModelTransiGoodsModel34 });
app.model({ namespace: 'finishedRateReport.model', ...ModelFinishedRateReportModel35 });
app.model({ namespace: 'formula.model', ...ModelFormulaModel36 });
app.model({ namespace: 'productionBoard.model', ...ModelProductionBoardModel37 });
app.model({ namespace: 'productionPlan.model', ...ModelProductionPlanModel38 });
app.model({ namespace: 'productionProcess.model', ...ModelProductionProcessModel39 });
app.model({ namespace: 'productionStorage.model', ...ModelProductionStorageModel40 });
app.model({ namespace: 'purchaseOrder.model', ...ModelPurchaseOrderModel41 });
app.model({ namespace: 'receiveOrder.model', ...ModelReceiveOrderModel42 });
app.model({ namespace: 'returnOrder.model', ...ModelReturnOrderModel43 });
app.model({ namespace: 'summaryDetails.model', ...ModelSummaryDetailsModel44 });
app.model({ namespace: 'supplier.model', ...ModelSupplierModel45 });
app.model({ namespace: 'supplierUser.model', ...ModelSupplierUserModel46 });
app.model({ namespace: 'supply.model', ...ModelSupplyModel47 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
